// MortgageBrokerLayout.jsx
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import ApplyNow from './ApplyNow/ApplyNow';
import ContactMe from './ContactMe/ContactMe';
import BrokerCard from '../BrokerCard/BrokerCard';
import "./index.css";

const MortgageBrokerLayout = ({ brokerData }) => {
  return (
    <div className="mortgage-broker-wrapper">
      {/* Floating Background Disks */}
      <div className="floating-disks">
        <div className="floating-disk disk-1"></div>
        <div className="floating-disk disk-2"></div>
        <div className="floating-disk disk-3"></div>
      </div>
      
      <Container className="p-0 position-relative">
        <Row className="g-0 broker-info-section-row">
          <Col lg={4} md={12} className="apply-now-section">
            <ApplyNow brokerName={brokerData.name} />
          </Col>
          <Col lg={4} md={12} className="broker-card-section">
            <BrokerCard brokerData={brokerData} showContactInfo={true} />
          </Col>
          <Col lg={4} md={12} className="contact-section">
            <ContactMe secondsToStart={60} brokerData={brokerData} />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default MortgageBrokerLayout;